import i18n from "i18next";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import styles from "../../pages/Layout.module.scss";

interface LanguageSwitcherProps {
    isMobile?: boolean;
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({isMobile}) => {
    useTranslation();

    const changeLang = (e: string) => {
        Cookies.set("lang", e);
        i18n.changeLanguage(e);
    };

    const lang = i18n.language;

    return (
        <a className={isMobile ? `btn d-block ${styles.btnMobile}` : "btn"} onClick={() => changeLang(lang === "cs" ? "en" : "cs")}>
            {lang === "cs" ? "English" : "Česky"}
        </a>
    );
};

export default LanguageSwitcher;
